export const ATTACHMENTS_BUCKET = "attachments";
